
import _ from 'lodash';
// import useValueExchangeLabel from '@/utils/useValueExchangeLabel.js'
import { getLimitNum } from '@/views/producer/common-template/selling-strategy.js';
import { GrantTypeLabel, statusOptions } from '@/common/permission';
import { getTotalAmount, getPrimaryAmount, getExtraAmount, getMaxAmount } from '../utils';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    },
    oldAuthorizeInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    newAuthorizeInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    advertiserList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    templateList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      title: '确认按变更后逻辑执行配置？',
      tableData: []
    };
  },

  computed: {
    innerVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  watch: {
    innerVisible: function innerVisible(val) {
      if (val) {
        this.cookTableData();
      }
    }
  },
  methods: {
    submit: function submit() {
      this.$emit('update:visible', false);
      this.$emit('submit');
    },
    cookNewAuth: function cookNewAuth() {},
    cookTableData: function cookTableData() {
      var _this = this;

      var showKeys = {
        adv_name: '授权客户名称',
        // mws_account_type: '账号类型',
        grant_type: '订阅类型',
        expired_time: '到期时间',
        template_names: '授权模板',
        plan_name: '套餐名称',
        status: '激活状态',
        p_download_push: '套餐可玩额度',
        e_download_push: '补充可玩额度',
        p_video_credits: '套餐视频额度',
        e_video_credits: '补充视频额度',
        storage: '购买存储空间',
        online: '购买在线人数',
        delay_days: '购买延期时间',
        voice_slots: '最大存储语音数',
        voice_edits: '语音编辑数'
      };
      var defaultValue = {
        adv_name: '-',
        // mws_account_type: '-',
        grant_type: '-',
        expired_time: '-',
        template_names: '-',
        plan_name: '-',
        status: '-',
        p_download_push: '-',
        p_video_credits: '-',
        e_download_push: '-',
        e_video_credits: '-',
        storage: '-',
        online: '-',
        delay_days: '-',
        voice_slots: '-',
        voice_edits: '-'
      };
      var oldValue = _.assign({}, defaultValue, this.oldAuthorizeInfo);
      var newValue = _.assign({}, defaultValue, this.newAuthorizeInfo);

      var getNames = function getNames(names) {
        if (names === null) {
          return 'All';
        }

        return names.join(',');
      };
      var isNormalAccountType = function isNormalAccountType(value) {
        if (newValue.account_type === 'normal') {
          return value;
        }
        return '-';
      };
      var tabledataTemp = [];
      _.forEach(showKeys, function (item, key) {
        var tempData = {
          label: item
        };

        switch (key) {
          // case 'adv_name':
          //   tempData.old =
          //     useValueExchangeLabel(oldValue[key], this.advertiserList) || '-'
          //   tempData.new =
          //     useValueExchangeLabel(newValue[key], this.advertiserList) || '-'
          //   break
          // case 'mws_account_type':
          //   tempData.old =
          //     useValueExchangeLabel(oldValue[key], mwsAccountTypeList) || '-'
          //   tempData.new =
          //     useValueExchangeLabel(newValue[key], mwsAccountTypeList) || '-'
          //   break
          case 'grant_type':
            tempData.old = GrantTypeLabel[oldValue[key]] || '-';
            tempData.new = GrantTypeLabel[newValue[key]] || '-';
            break;
          case 'template_names':
            tempData.old = getNames(oldValue.template_names);
            tempData.new = getNames(newValue.template_names);
            break;
          case 'status':
            tempData.old = statusOptions[oldValue[key]] || '-';
            tempData.new = statusOptions.active;
            break;
          case 'p_download_push':
            tempData.old = getPrimaryAmount(oldValue, 'download_push') + ',' + getPrimaryAmount(oldValue, 'download_push', 'balance');
            tempData.new = _this.getNewPrimaryAmount(newValue, 'download_push', 'amount') + ',' + _this.getNewPrimaryAmount(newValue, 'download_push', 'balance');
            break;
          case 'e_download_push':
            tempData.old = getExtraAmount(oldValue, 'download_push') + ',' + getExtraAmount(oldValue, 'download_push', 'balance');
            tempData.new = _this.getNewExtraAmount(newValue, 'download_push', 'amount') + ',' + _this.getNewExtraAmount(newValue, 'download_push', 'balance');
            break;
          case 'p_video_credits':
            {
              var old = getPrimaryAmount(oldValue, 'video_credits');
              var balance = getPrimaryAmount(oldValue, 'video_credits', 'balance');
              tempData.old = old + ',' + balance;

              var news = _this.getNewPrimaryAmount(newValue, 'video_credits');
              var newBalance = _this.getNewPrimaryAmount(newValue, 'video_credits', 'balance');
              tempData.new = news + ',' + newBalance;
            }
            break;
          case 'e_video_credits':
            {
              var _old = getExtraAmount(oldValue, 'video_credits');
              var _balance = getExtraAmount(oldValue, 'video_credits', 'balance');
              tempData.old = _old + ',' + _balance;

              var _news = _this.getNewExtraAmount(newValue, 'video_credits');
              var _newBalance = _this.getNewExtraAmount(newValue, 'video_credits', 'balance');
              tempData.new = _news + ',' + _newBalance;
            }
            break;
          // case 'video_credits':
          //   {
          //     const old = getTotalAmount(oldValue, key)
          //     const balance = getTotalAmount(oldValue, key, 'balance')
          //     tempData.old = `${old},${balance}`

          //     const news = this.getNewTotalAmount(newValue, key)
          //     const newBalance = this.getNewTotalAmount(
          //       newValue,
          //       key,
          //       'balance',
          //     )
          //     tempData.new = `${news},${newBalance}`
          //   }
          //   break
          case 'storage':
          case 'online':
          case 'voice_slots':
          case 'voice_edits':
            tempData.old = getMaxAmount(oldValue, key) + ',' + getMaxAmount(oldValue, key, 'balance');
            tempData.new = _this.getNewMaxAmount(newValue, key, 'amount') + ',' + _this.getNewMaxAmount(newValue, key, 'balance');
            break;
          case 'expired_date':
          case 'adv_name':
          case 'plan_name':
            tempData.old = oldValue[key];
            tempData.new = newValue[key];
            break;
          case 'delay_days':
            tempData.old = oldValue[key];
            tempData.new = newValue['days'];
            break;
          default:
            tempData.old = getLimitNum(oldValue[key]);
            tempData.new = isNormalAccountType(getLimitNum(newValue[key]));
            break;
        }
        if (tempData.old === tempData.new) {
          tempData.diff = false;
        } else {
          tempData.diff = true;
        }
        tempData.key = key;
        tabledataTemp.push(tempData);
      });
      this.tableData = tabledataTemp;

      console.log(this.tableData);
    },
    getNewPrimaryAmount: function getNewPrimaryAmount(row, key, amount) {
      var isPrimary = this.newAuthorizeInfo.parent_id === 0; // 是否主套餐

      if (isPrimary) {
        return getPrimaryAmount(row, key, amount);
      }
      return getPrimaryAmount(this.oldAuthorizeInfo, key, amount);
    },
    getNewExtraAmount: function getNewExtraAmount(row, key, amount) {
      var newUsage = this.newAuthorizeInfo.usages[key] || [];
      var oldUsage = this.oldAuthorizeInfo.usages[key] || [];
      var _row = {
        plan_settings: this.newAuthorizeInfo.plan_settings,
        usages: {}
      };

      _row.usages[key] = newUsage.concat(oldUsage);

      return getExtraAmount(_row, key, amount);
    },
    getNewTotalAmount: function getNewTotalAmount(row, key, amount) {
      var isPrimary = this.newAuthorizeInfo.parent_id === 0; // 是否主套餐

      if (isPrimary) {
        return getTotalAmount(row, key, amount);
      }
      var newUsage = this.newAuthorizeInfo.usages[key] || [];
      var oldUsage = this.oldAuthorizeInfo.usages[key] || [];
      var _row = {
        plan_settings: this.newAuthorizeInfo.plan_settings,
        usages: {}
      };

      _row.usages[key] = newUsage.concat(oldUsage);

      return getTotalAmount(_row, key, amount);
    },
    getNewMaxAmount: function getNewMaxAmount(row, key, amount) {
      var isPrimary = this.newAuthorizeInfo.parent_id === 0; // 是否主套餐

      if (isPrimary) {
        return getMaxAmount(row, key, amount);
      }
      var newUsage = this.newAuthorizeInfo.usages[key] || [];
      var oldUsage = this.oldAuthorizeInfo.usages[key] || [];
      var _row = {
        plan_settings: this.newAuthorizeInfo.plan_settings,
        usages: {}
      };

      _row.usages[key] = newUsage.concat(oldUsage);

      return getMaxAmount(_row, key, amount);
    },
    cookUnlimited: function cookUnlimited(val) {
      var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'amount';

      if (!val) {
        return '-';
      }
      if (val && val[key] === -1) {
        return '无限制';
      }
      return val[key];
    }
  }
};